module.exports = __webpack_public_path__ + "static/media/visionWhiteLogo.9688dea1.png";